<template>
  <f7-list media-list v-if="companies" class="searchbar-found" id="companies-list">
    <f7-list-item>
      <b-row>
        <b-col class="text-center boldLabel">
          {{$t('administration.user_id') + ' :'}}
        </b-col>
        <b-col class="text-center boldLabel">
          {{$t('administration.company_number') + ' :'}}
        </b-col>
        <b-col class="text-center boldLabel">
          {{$t('administration.company_name') + ' :'}}
        </b-col>
      </b-row>
    </f7-list-item>
    <f7-list media-list v-for="(companiesGroup, key) in companies" :key="key">
      <f7-list-item :title="key" group-title></f7-list-item>
      <f7-list-item class="boxRequest" v-for="company in companiesGroup" :key="company.Id">
        <b-row @click="seeDetails(company)">
          <b-col class="text-center">
            {{ company.Id }}
          </b-col>
          <b-col class="text-center">
            {{ company.Login }}
          </b-col>
          <b-col class="text-center">
            {{ company.Name }}
          </b-col>
        </b-row>
      </f7-list-item>
    </f7-list>
  </f7-list>
</template>

<script>

import {loadPage} from '@/helpers/routing'

export default {
  name: 'ListUsers',
  components: {

  },
  props: ['companies'],
  data () {
    return {
    }
  },
  created () {

  },
  mounted () {

  },
  beforeDestroy () {

  },
  methods: {
    seeDetails: function (company = null) {
      if (!company) {
        return
      }
      if (!company.Id) {
        return
      }
      loadPage(this, {
        url: '/administration/company/' + company.Id
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CompaniesList.vue?0e227ee0